import React, { useState } from "react";
import Buttons from "../../components/Elements/Buttons";
import DonationPopup from "../../components/DonationPopup";

const Cover = () => {
  const [isDonationPopupOpen, setIsDonationPopupOpen] = useState(false);

  const handleJoinMission = () => {
    setIsDonationPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsDonationPopupOpen(false);
  };

  return (
    <div className="relative w-full h-[716px] max-lg:h-[60vh] overflow-hidden">
      {/* Background Image */}
      <img
        src="/assets/home-cover-image.jpg"
        alt="Cover"
        className="w-full h-full object-cover object-top"
      />

      {/* Overlay Layer for contrast */}
      <div className="absolute inset-0 bg-black/20"></div>

      {/* Text Content */}
      <div className="absolute left-20 top-40 max-lg:left-6 max-lg:top-1/4">
        <div className="text-white lg:w-[470px] md:w-[300px]">
          <p className="text-[55px] font-source-serif-4 font-semibold leading-tight max-lg:text-3xl ">
            सर्वे सन्तु सनातनाः
          </p>
          <p className="text-[17px] font-inter font-semibold leading-8">
            हर प्राणी, हर चेतना में वही सनातन तत्व जागृत हो 
            यही इस उद्घोष का सार है, कि कोई पराया नहीं, सब उसी प्रकाश के अंश हैं।
            यह विविधता का विलय नहीं, उसे एक साझा सत्य में जोड़ने का सनातन संकल्प है।
          </p>
        </div>
        <div className="mt-10 flex gap-5">
          <button onClick={handleJoinMission}>
            <Buttons
              textColor="black"
              color="white"
              buttonText={"Join Our Mission"}
            />
          </button>

           {/* <Buttons
            textColor="white"
            color="transparent"
            className="border border-1 border-solid"
            buttonText={"Join Us"}
          /> */}
        </div>
      </div>

      {/* Donation Popup */}
      <DonationPopup 
        isOpen={isDonationPopupOpen} 
        onClose={handleClosePopup} 
      />
    </div>
  );
};

export default Cover;
